{
  "title": "Beast Bond",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "1st-level divination",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a bit of fur wrapped in cloth)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You establish a telepathic link with one beast you touch that is friendly to you or charmed by you. The spell fails if the beast’s Intelligence is 4 or higher. Until the spell ends, the link is active while you and the beast are within line of sight of each other. Through the link, the beast can understand your telepathic messages to it, and it can telepathically communicate simple emotions and concepts back to you. While the link is active, the beast gains advantage on attack rolls against any creature within 5 feet of you that you can see."
  ],
  "spellLists": ["druid", "ranger"]
}
